import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const ElectricsGlyph = /*#__PURE__*/createElement("g", {
  id: "electrics"
}, /*#__PURE__*/createElement("path", {
  d: "M27.6,44.2h12.7c0.9,0,1.8,0.5,2.3,1.2c0.5,0.8,0.6,1.7,0.2,2.6c0,0,0,0,0,0L34.6,66l23.1-27.5H45c-0.9,0-1.8-0.5-2.3-1.2 c-0.5-0.8-0.6-1.7-0.2-2.6l8.2-17.9L27.6,44.2z M28.8,76.5c-0.3,0-0.5-0.1-0.8-0.2c-0.6-0.4-0.8-1.2-0.5-1.8L40,47.1H24.5 c-0.6,0-1.1-0.3-1.3-0.8c-0.2-0.5-0.2-1.1,0.2-1.5L55.3,6.7c0.5-0.6,1.3-0.7,1.9-0.3c0.6,0.4,0.8,1.2,0.5,1.8L45.3,35.5h15.5 c0.6,0,1.1,0.3,1.3,0.8c0.2,0.5,0.2,1.1-0.2,1.5L29.9,76C29.7,76.3,29.2,76.5,28.8,76.5"
}));
const Electrics = createSvg({
  name: 'electrics',
  path: ElectricsGlyph
});

export default Electrics;
export { ElectricsGlyph };
